import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/flags/1x1/no.svg")